import React from 'react'
import { graphql } from "gatsby";
import { GatsbyImage as Image, getImage } from "gatsby-plugin-image";
import { renderContent } from "../../utilities/renderContent";
import CtaButton from '../elements/CtaButton';

export default function HowItWorksBlock({ data }) {
  const { callToActionButtonText, callToActionButtonLink, heading, featuredMedia, copy } = data

  return (
    <section className="hds-container bg-gradient hds-text-color relative z-10">
      {/* Add className "bullseye1-bg" to div below to apply bullseye background for this component */}
      <div className="w-full md:flex text-left hds-transition text-white flex-row-reverse">
        <div className="overflow-visible w-full md:w-1/2 hds-transition fade-item fade-up z-10 relative is-showing">
          <div className="object-cover object-center h-full w-full max-w-md md:-mt-12">
            <Image
              image={getImage(featuredMedia)}
              alt={featuredMedia.alt}
              opacity={0}
            />
          </div>
        </div>
        <div className="md:w-1/2 p-6 md:p-20 self-center max-w-xl hds-transition fade-item fade-up z-10 is-showing">
          <h4 className="font-heading uppercase font-bold pb-2 leading-tight text-2xl mb-4">
            {heading}
          </h4>
          <div dangerouslySetInnerHTML={renderContent(copy)} />
          {callToActionButtonLink && callToActionButtonText && (
            <CtaButton link={callToActionButtonLink} text={callToActionButtonText} />
          )}
        </div>
      </div>
    </section>
  )
}

export const howItWorksQuery = graphql`
  fragment HowItWorksComponent on DatoCmsHowItWorksBlock {
    internal {
      type
    }
    id
    callToActionButtonText
    callToActionButtonLink
    heading
    copy
    featuredMedia {
      alt
      gatsbyImageData
    }
  }
`